// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__2m4ti","spin":"Spinner_spin__3Qot0","fixed":"Spinner_fixed__1Q09_"};